<template>
  <b-modal
    v-model="modal"
    centered
    @hidden="hideModal"
    size="sm"
    title="Autorización requerida"
    hide-footer
  >
    <div class="text-center">
      <b-spinner v-if="loading" label="Spinning"></b-spinner>
    </div>

    <b-form @submit.prevent="onSubmitAuthorization" autocomplete="off">
      <b-form-group label="Usuario:" label-for="" description="">
        <b-form-input
          type="text"
          v-model="$v.form.authorizationUser.$model"
          :state="
            $v.form.authorizationUser.$dirty
              ? !$v.form.authorizationUser.$error
              : null
          "
          placeholder=""
        >
        </b-form-input>
      </b-form-group>

      <b-form-group label="Contraseña:" label-for="" description="">
        <b-form-input
          type="password"
          v-model="$v.form.authorizationPassword.$model"
          :state="
            $v.form.authorizationPassword.$dirty
              ? !$v.form.authorizationPassword.$error
              : null
          "
          placeholder=""
        >
        </b-form-input>
      </b-form-group>

      <div class="w-100">
        <button
          class="btn btn-primary float-right ml-1"
          type="submit"
          :disabled="loading == true"
        >
          Autorizar
        </button>
        <b-button class="btn btn-primary float-right ml-1" @click="hideModal"
          >Cancelar</b-button
        >
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import Vue from "vue";

import miniToastr from "mini-toastr";
import {
  decimal,
  integer,
  required,
  requiredIf
} from "vuelidate/lib/validators";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });
Vue.use(miniToastr);

export default {
  name: "authorizationModal",
  components: {},
  props: {
    modal: { type: Boolean },
    obj: { type: Object }
  },
  data() {
    return {
      loading: false,
      form: {
        authorizationUser: null,
        authorizationPassword: null
      }
    };
  },
  methods: {
    hideModal() {
      this.form.authorizationUser = "";
      this.form.authorizationPassword = "";
      this.$emit("hideAuthorizationModal");
    },
    onSubmitAuthorization() {
      this.$v.form.$touch();
      if (this.$v.$invalid == true) {
        this.$toast.info("Campos restantes en el formulario", "");
      } else {
        let payload = {
          username: this.form.authorizationUser,
          password: this.form.authorizationPassword
        };

        this.loading = true;

        this.$axios
          .post("/api/v1/authorization-process/", payload)
          .then((response) => {
            this.loading = false;
            if (response.data.status == 1) {
              this.$emit("methodDynamic", this.obj);
              this.hideModal();
              miniToastr.success("Autorización realizada con éxito", "");
            }

            if (response.data.status == 0) {
              miniToastr.warn(
                "El credenciales proporcionadas no son correctas",
                ""
              );
            }

            if (response.data.status == 2) {
              miniToastr.warn(
                "El usuario ingresado no esta autorizado para realizar esta operación",
                ""
              );
            }
          })
          .catch(function (error) {
            this.loading = false;
            miniToastr.error("Problemas al realizar la operación", "");
          });
      }
    }
  },
  validations: {
    form: {
      authorizationUser: { required },
      authorizationPassword: { required }
    }
  }
};
</script>
